


































































helpers = require('../../helpers.coffee')

view_model =
  data: ->
    current_user: Session.current_user
    email: ''
    role: undefined
    company_id: Session.current_company.id
    companies: []
    company: Session.current_company
    company_options: []
    company_name: Session.current_company.name
    next_page: 1
    text_field_filter: ''
    attrs: {
      placeholder: "Digite o nome da empresa"
    }

  methods:
    roleHaveSeats: (role) ->
      if @company?
       role in @company.available_roles()
      else
        true

    submit: ->
      return @errors.add('role', 'O campo função precisa ser definido') if !@role

      @$validator.validateAll({@email, @role}).then (success) =>
        @inviteUser() if success

    inviteUser: ->
      Loader.on()
      new UsersResource().inviteUser(@inviteSuccess, @handleApiErrors, {@email, @role, @company_id})

    inviteSuccess: ->
      Loader.off()
      IntercomCtrl.trackEvent('Convidou usuário', { 'Email': @email, 'Função': @role, @company_id })
      @$router.push('/configuracoes/usuarios')
      alertify.success "Usuário convidado com sucesso!"

    loadCompanies: ->
      new CompaniesResource().index @loadCompaniesSuccess, @loadCompaniesError, params: { limit: '5' }

    loadCompaniesSuccess: (data) ->
      @loading = false
      @company_options = []
      for company in data.companies
        @company_options.push(company.name)
        @companies.push company

    selectedCompany: (company) ->
      if @companies.length > 0
        @company = @companies.find (c) -> c.name == company
        @company_id = @company.id if @company

    searchCompanies: (search) ->
      return if @loading || search.length < 3
      @loading = true
      params = { q: { search_query: search }, limit: '5' }
      new CompaniesResource().index(@loadCompaniesSuccess, @loadCompaniesError, {params})

    loadCompaniesError: ->
      @loading = false

  beforeCreate: ->
    if Session.current_user.isSeller()
      @$router.push('/configuracoes/usuarios')

  created: ->
    @loadCompanies() if Session.current_user.isAdmin()

  mounted: ->
    @errors.clear()

exports.default = helpers.vue_include(view_model, helpers.form)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/users/invitation_form.vue